module.exports = __webpack_public_path__ + "img/inapp-royal-emblem-transparent.988c52a2.png";